import React from "react";
import PropTypes from "prop-types";
import { UTILS } from "utils";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
import {
  useDeleteCountryMutation,
  useGetAddedCountriesMutation,
} from "redux/shipping-methods/shipping-service";
import { AreasAction } from "redux/actions";
const DeleteCountry = ({ open, selectedRow, onClose, selectedAreas }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteCountry] = useDeleteCountryMutation();
  const [getAddedCountries] = useGetAddedCountriesMutation();
  const { selectedStore } = useSelector((state) => state.AreasReducer);
  const { isLoading } = useSelector((state) => state.LoaderReducer);

  const delete_countries = UTILS.withTryCatch(async () => {
    const userDetail = UTILS.getCurrentUser();
    let objectArray = [];
    selectedAreas.forEach((country) => {
      objectArray.push(country._id);
    });

    const obj = {
      areas: objectArray,
      brandId: userDetail.brandId,
      storeId: selectedStore.value,
    };

    await deleteCountry(obj).unwrap();
    await getAddedCountries(obj);
    onClose();
    dispatch(AreasAction.setSync());
  });

  const countryName =
    selectedRow && selectedRow.length === 1
      ? selectedRow[0]?.countryID?.countryNameEN || ""
      : "";

  return (
    <AppModal
      open={open}
      onClose={onClose}
      width={550}
      closable={false}
      loading={isLoading}
      footer={
        <div className="mx-auto flex w-full max-w-[760px] items-center justify-center gap-4">
          <AppButton
            variant="secondary"
            size="lg"
            className=" w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
            onClick={onClose}
          >
            No, Keep It
          </AppButton>
          <AppButton
            variant="primary"
            size="lg"
            className="w-1/2 text-4xl"
            onClick={delete_countries}
            loading={isLoading}
          >
            Yes, Delete
          </AppButton>
        </div>
      }
    >
      <div className="flex flex-col items-center px-8 text-center">
        <div className="mb-6 h-44 w-44 mt-6">
          <AppIcon name="trashRed" size={170} className="h-full w-full" />
        </div>
        <h1 className="text-24px font-semibold text-gray-900">Delete Country</h1>
        <p className=" text-3xl text-gray-500 mb-0">
          {selectedRow && selectedRow.length === 1
            ? `Are you sure you want to delete ${countryName}`
            : t("Are you sure you want to delete the selected countries")}
        </p>
      </div>
    </AppModal>
  );
};

DeleteCountry.propTypes = {
  open: PropTypes.bool,
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
};
export default DeleteCountry;
